<template>
  <div>
    <modal
      name="thumbnailListModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div id="modalAreaThumbnailList" class="modalArea">
        <div class="content cleafix">

          <!-- <h2>カテゴリ別で作品を見る</h2> -->
          <h2>一覧で作品を見る</h2>

          <!--<div id="menuThumbnailList">
            <div id="menu01" :class="tag == '' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode01" @click="searchWorkByTag('')"></div>
            <div id="menu02" :class="tag == '春' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode02" @click="searchWorkByTag('春')"></div>
            <div id="menu03" :class="tag == '夏' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode03" @click="searchWorkByTag('夏')"></div>
            <div id="menu04" :class="tag == '秋' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode04" @click="searchWorkByTag('秋')"></div>
            <div id="menu05" :class="tag == '冬' ? 'on' : 'fade'"><img src="/img/blank.gif" alt="mode05" @click="searchWorkByTag('冬')"></div>
          </div>-->
          <div id="thumbnailList">
            <div v-for="(work) in works" :key="work.id" class="thumbnailArea">
              <div class="thumbnailImg fade" :style="`background-image:url(${work.thumbnailUrl})`" @click="clickWork(work)"><img src="/img/blank.gif"></div>
            </div><!-- /thumbnailArea -->
          </div><!-- /photoList -->

        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
import enumMixin from '@/concern/enumMixin'
export default {
  mixins: [enumMixin], // Enum値の読み込み
  props: [
    'works',
    'mode',
    'open',
    'tag'
  ],
  data () {
    return {
    }
  },
  computed: {
    mode01ON () {
      return this.mode === this.EnumMode01 ? 'on' : 'fade'
    },
    mode02ON () {
      return this.mode === this.EnumMode02 ? 'on' : 'fade'
    },
    mode03ON () {
      return this.mode === this.EnumMode03 ? 'on' : 'fade'
    },
    mode04ON () {
      return this.mode === this.EnumMode04 ? 'on' : 'fade'
    },
    mode05ON () {
      return this.mode === this.EnumMode05 ? 'on' : 'fade'
    }
  },
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('thumbnailListModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '相模原市フォトスポットサイト'
    },
    changeMode (mode) {
      // モードの切り替え
      this.$emit('change', mode)
    },
    // タグによる検索処理
    searchWorkByTag (tag) {
      this.$emit('searchWorkByTag', tag)
    },
    clickWork (work) {
      this.closeModal()
      this.$emit('click', work)
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('thumbnailListModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
</style>
